import type { RuntimeConfig } from '@/shared/config'
import { IdleRealtimeClient } from './idle-realtime-client'
import type { RealtimeClient } from './types'
import { WsRealtimeClient, resolveWsUrl } from './ws-realtime-client'

/** Realtime data comes only from the WebSocket; without a configured URL there is none. */
export function createRealtimeClient(
  config: Pick<RuntimeConfig, 'wsBaseUrl'>,
  location: Pick<Location, 'protocol' | 'host'> = window.location,
): RealtimeClient {
  if (config.wsBaseUrl === undefined) return new IdleRealtimeClient()
  return new WsRealtimeClient(resolveWsUrl(config.wsBaseUrl, location))
}
